import FieldFormView from "./FieldFormView";

function FieldForm({
  setPrinterData,
  selectedLabelItem,
  selectedLabelItemIndex,
  submitError,
  fields,
}) {
  /**
   * This method will handle the field change event.
   * @param {int} value
   */
  function onFieldChange(value) {
    setPrinterData((prev) => ({
      ...prev,
      label_items: prev.label_items.map((item, index) =>
        index === selectedLabelItemIndex
          ? {
              ...item,
              field_id: value,
            }
          : item
      ),
    }));
  }

  return (
    <FieldFormView
      setPrinterData={setPrinterData}
      selectedLabelItem={selectedLabelItem}
      selectedLabelItemIndex={selectedLabelItemIndex}
      onFieldChange={onFieldChange}
      submitError={submitError}
      fields={fields}
    />
  );
}

export default FieldForm;
